// extracted by mini-css-extract-plugin
export var background = "hero-module--background--1a870";
export var content = "hero-module--content--7c6c0";
export var hero = "hero-module--hero--496e5";
export var image = "hero-module--image--560de";
export var logo = "hero-module--logo--41dac";
export var scroll = "hero-module--scroll--a7d9b";
export var scrollImageWrapper = "hero-module--scrollImageWrapper--a4e62";
export var scrollWrapper = "hero-module--scrollWrapper--3ed27";